import React from 'react'
import replaceNewline from '../../../functions/replaceNewline'
import getFormatedPrice from '../func/getFormatedPrice'


const EditEventFormPrintExtra = ({eventData}) => {
    if(!eventData.extra || (!eventData.extra && !eventData.extra_price)) {
        return ''
    }

    if(eventData.extra_price) {
        return (
            <div  className="container-2-1 margin-bottom ">
                <p className="text-small-light" dangerouslySetInnerHTML={{__html: replaceNewline(eventData.extra)}}/>
                <p className="align-self-end text-small-light">= {getFormatedPrice(eventData.extra_price)}</p>
            </div>
        )

    } else {
        return <div className="margin-bottom text-small-light" dangerouslySetInnerHTML={{__html: replaceNewline(eventData.extra)}}/>
    }
}

export default EditEventFormPrintExtra
